import React from 'react';
import Icon from '../../../components/AppIcon';

const DiscountButtons = ({ offers }) => {
  if (!offers || offers.length === 0) return null;
  return (
    <div className="bg-card border-b border-border">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          
          
          {offers.map((offer, index) => (
            <button
              key={index}
              className="flex items-center justify-center gap-2 bg-primary text-primary-foreground px-2 py-1.5 rounded-xl font-medium text-base md:text-lg hover:bg-primary/90 transition-colors duration-250 warm-shadow-md"
            >
              <img
                src={
                  offer?.icon
                    ? `${BASE_URL}/storage/${offer.icon}`
                    : "/assets/images/lo.svg"
                }
                alt="خصم"
                className="w-4 h-4 object-contain"
              />

              <span>{offer?.title}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DiscountButtons;